import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({ providedIn: 'root' })
export class ConfigService {

  private appInsights: ApplicationInsights;

  load(): Promise<void> {
    return fetch('/assets/config.json')
      .then(r => r.json())
      .then(config => {
        if (config.baseUrl) {
          (environment as any).baseUrl = config.baseUrl;
        }
        if (config.urlTef) {
          (environment as any).urlTef = config.urlTef;
        }
        if (config.urlWebhookApi) {
          (environment as any).urlWebhookApi = config.urlWebhookApi;
        }
        if (config.appInsightsConnectionString) {
          this.appInsights = new ApplicationInsights({
            config: {
              connectionString: config.appInsightsConnectionString,
              enableAutoRouteTracking: true,
              disableFetchTracking: false,
              enableCorsCorrelation: true,
              // Allowlist: headers de correlação somente para nossa própria API.
              // Qualquer outra origem (viacep.com.br, etc.) não recebe Request-Id/traceparent.
              correlationHeaderDomains: [
                'api.portaldoalunocurso.com.br',
                'homolog-api.portaldoalunocurso.com.br',
                'app-globalmanageapi-prd-preprod.azurewebsites.net',
                'preprod-webhook.portaldoalunocurso.com.br'
              ]
            }
          });
          this.appInsights.loadAppInsights();
          (environment as any).appInsights = this.appInsights;
        }
      })
      .catch(() => {
        // Fallback: usa o valor compilado do environment
      });
  }

  trackException(error: Error): void {
    if (this.appInsights) {
      this.appInsights.trackException({ exception: error });
    }
  }

  trackEvent(name: string, properties?: { [key: string]: string }): void {
    if (this.appInsights) {
      this.appInsights.trackEvent({ name }, properties);
    }
  }
}
